import { fromJS } from 'immutable';
import * as actions from '@modules/conferencing/actions/checkInSearch';
import { SUCCESS, START, ERROR } from '@modules/conferencing/actions/global';
import { fetchingState } from '@constants';
import * as _ from 'lodash';

const initialStats = {
  searchResults: { data: [], state: null},
  searchFilters: {},
  searchModifier: null,
  lastSearch: {},
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 500,
    rowsPerPageOptions: [5, 10, 25, 50, 100, 500, 1000, 5000, 10000],
    sortModel: ''
  }
};

export default (state = fromJS(initialStats), action) => {
    switch (action.type) {
        case actions.SEARCH[START]: {
          return state
            .setIn(['searchResults', 'state'], fetchingState.FETCHING)
            .setIn(['searchFilters'], action.payload)
            .setIn(['pagination', 'page'], action.page)
            .setIn(['pagination', 'rowsPerPage'], action.pageSize);
        }
        case actions.SEARCH[SUCCESS]: {
          return state
            .setIn(['searchResults', 'state'], fetchingState.LOADED)
            .setIn(
              ['searchResults', 'data'],
              fromJS(_.get(action, 'data.results', [])),
            )
            .setIn(['pagination', 'count'], _.get(action, 'data.totalCount', 0));
          }
        case actions.SEARCH[ERROR]: {
          return state.setIn(['searchResults', 'state'], fetchingState.ERROR);
        }
          
        case actions.CHANGE_PAGE: {
          return state.setIn(['pagination', 'page'], action.payload);
        }
        case actions.CHANGE_ROWS_PER_PAGE: {
          return state.setIn(['pagination', 'rowsPerPage'], action.payload);
        }
        case actions.CHANGE_SORT_MODEL: {
          return state.setIn(['pagination', 'sortModel'], action.payload);
        }
    default:
      return state;
  }
};
